import React from 'react';
import { DateTime } from 'luxon';
import { LettingWidgetBase } from '../LettingWidgetBase/LettingWidgetBase';
import styles from './AccountBalanceWidget.module.scss';
export const AccountBalanceWidget = ({ total, latestTransactionDate, latestTransactionAmount, onClick, isClosed = false, }) => {
    return (<LettingWidgetBase iconUrl='https://www.haven.com/assets/owners/lettings/balance.svg' title='Finance' isClosed={isClosed} onClick={onClick} subtitle='Latest transaction'>
      <div className={styles.contentWrapper}>
        <p className={styles.transactionDetails}>
          <span>{DateTime.fromJSDate(latestTransactionDate).toFormat('dd LLL yyyy')}</span>
          <span>£{latestTransactionAmount}</span>
        </p>

        <div className={styles.divider}/>

        <p className={styles.total}>
          <span>Total</span>
          <span className={styles.totalAmount}>£{total}</span>
        </p>
      </div>
    </LettingWidgetBase>);
};
